module.exports = __webpack_public_path__ + "img/class9.e3ce4d56.webp";